export const STATUS = {
  PROCESSING: 'PROCESSING',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  VALID: 'VALID',
  INVALID: 'INVALID'
};
